<template>
  <div
    id="app"
    :class="appClass"
  >
    <header-claro v-if="useHeader" />

    <div class="app__content">
      <router-view />
    </div>

    <g-tag-manager :google-tag-id="googleTagId" />
  </div>
</template>

<script>
import storage from '@npm/key-storage';
import {
  GTAG_MANAGER
} from '@/utils/constants';
import getUrlParams from '@/utils/getUrlParams';
import { getApp } from '@/utils/starters';
import GTagManager from '@/components/GTagManager';

export default {
  name: 'Home',
  components: {
    GTagManager
  },
  data() {
    return {
      appClass: '',
      useHeader: true
    };
  },
  computed: {
    googleTagId() {
      return GTAG_MANAGER[this.$store.state?.country?.pais].code;
    }
  },
  created() {
    this.setMpcToken();
    this.setClassAndApp();
  },
  methods: {
    setMpcToken() {
      const token = getUrlParams('t');
      if (token) {
        storage.set('tokenIvr', token);
      }
    },
    setClassAndApp() {
      const app = getApp();
      this.$store.setApp(app);
      this.appClass = app.toLowerCase();

      this.$LogRocket.track('Channel', {
        name: app
      });

      if (this.$store.isMCA()) this.useHeader = false;
    }
  }
};
</script>

<style lang="scss">
@import '@/assets/css/main.scss';
#app {
  margin: 0;
  background-image: url("../img/claro_watermark2.png");
  background-repeat: no-repeat;
  background-position: bottom left;
  background-attachment: fixed;
  background-size: 200px;
  min-height: 100vh;
}

.app__content {
  padding: 0 15px 3rem 15px;
  max-width: 630px;
  margin: 0 auto;
}
</style>
